import { Tooltip } from '@routable/gross-ds';
import React, {} from 'react';
import { VendorsCannotReceiveInvoicesText } from './VendorsCannotReceiveInvoicesText';
export const VendorsCannotReceiveInvoicesTooltip = ({ children, isShown }) => {
    return (React.createElement(Tooltip, { className: "w-full", closeDelay: 100, "data-testid": "tooltip--vendors-cannot-receive-invoices", position: "right", tooltip: isShown ? React.createElement(VendorsCannotReceiveInvoicesText, null) : null, variant: "light" }, children));
};
